import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { rem } from 'polished';

import Icon from '../Icon';
import Loader from '../Loader';
import selectArrowIcon from '../../assets/select-arrow.svg';

const Select = styled.select`
  width: 100%;
  border-radius: ${({ theme }) => theme.baseBorderRadius};
  color: ${({ theme }) => theme.textColor};
  font-size: ${rem(14)};
  font-family: ${({ theme }) => theme.fontFamily};
  outline: 0;
  background-color: #fff;
  border-radius: ${({ theme }) => theme.borderRadius};
  background-image: url(${selectArrowIcon});
  background-repeat: no-repeat;
  background-position: center right;
  height: ${rem(52)};
  padding: 0px ${rem(20)};
  padding-right: ${rem(50)};
  padding-left: ${({ leftIcon }) => (leftIcon ? rem(75) : rem(20))};
  border: none;
  appearance: none;
  font-family: 'Roboto', sans-serif;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'auto')};
  &::placeholder {
    color: ${({ theme }) => theme.color.font.primary};
  }
`;

const StyledLoader = styled(Loader)`
  margin-top: ${rem(12)};
  margin-left: ${rem(12)};
`;

const Span = styled.span`
  position: absolute;
  top: ${rem(6)};
  left: ${rem(15)};
`;

const Option = styled.option`
  padding: ${rem(19)} ${rem(21)} ${rem(17)};
  height: ${rem(20)};
`;

const OptGroup = styled.optgroup``;

const Wrapper = styled.div`
  width: 100%;
  position: relative;
  &:before {
    content: '';
    width: ${rem(65)};
    height: ${({ leftIcon }) => (leftIcon ? '100%' : '0')};
    position: absolute;
    background-color: ${({ theme }) => theme.color.base};
    border-top-left-radius: ${({ theme }) => theme.borderRadius};
    border-bottom-left-radius: ${({ theme }) => theme.borderRadius};
  }
`;

class CompSelect extends PureComponent {
  constructor(props) {
    super(props);
    this.renderOption = this.renderOption.bind(this);
  }
  renderOption(item) {
    return (
      <Option key={item.value} value={item.value}>
        {item.label}
      </Option>
    );
  }
  render() {
    const { leftIcon, isFetching } = this.props;
    return (
      <Wrapper leftIcon={!!leftIcon}>
        {leftIcon && (
          <Span>
            {isFetching ? (
              <StyledLoader />
            ) : (
              <Icon name={leftIcon} size="xl" color="#aaaaaa" />
            )}
          </Span>
        )}
        <Select
          leftIcon={!!leftIcon}
          {...this.props}
          innerRef={this.props.inputRef}
          id={this.props.id || this.context.id}
          onChange={this.props.onChange}
          disabled={this.props.disabled || isFetching}
        >
          {this.props.options.map(item => {
            if (Array.isArray(item.value)) {
              return (
                <OptGroup label={item.label} key={item.label}>
                  {item.value.map(this.renderOption)}
                </OptGroup>
              );
            }
            return this.renderOption(item);
          })}
        </Select>
      </Wrapper>
    );
  }
}

CompSelect.propTypes = {
  id: PropTypes.string,
  inputRef: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.arrayOf(
          PropTypes.shape({
            label: PropTypes.string.isRequired,
            value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
              .isRequired,
          }).isRequired,
        ),
      ]),
    }).isRequired,
  ).isRequired,
  leftIcon: PropTypes.string,
  disabled: PropTypes.bool,
  isFetching: PropTypes.bool,
};

CompSelect.defaultProps = {
  id: null,
  inputRef: () => {},
  leftIcon: null,
  isFetching: false,
  disabled: false,
};

CompSelect.contextTypes = {
  id: PropTypes.string,
};

export default CompSelect;



// WEBPACK FOOTER //
// ./src/components/Select/index.js